<script lang="ts">
	import Link from "./Link.svelte";

	export let enjoyJamujamHeadline = "";
	export let enjoyCol1Description = "";
	export let enjoyCol2Description = "";
	export let enjoyCol3Description = "";
	export let tryApp = "";
	export let href = "";
	/* eslint-disable svelte/no-at-html-tags */
</script>

<div class="bg-primary relative z-10 -mt-16 px-2 py-16 lg:rounded-md lg:px-36">
	<h2 class="text-md text-center leading-[1.1] lg:text-lg">{@html enjoyJamujamHeadline}</h2>
	<div
		class="my-8 flex flex-col items-center justify-center gap-8 lg:flex-row lg:items-start lg:justify-between lg:px-8 lg:py-16"
	>
		<div class="flex w-60 flex-col items-center text-center">
			<div class="text-xl font-semibold">1 000+</div>
			<div class="font-bold">{@html enjoyCol1Description}</div>
		</div>
		<div class="flex w-60 flex-col items-center text-center">
			<div class="text-xl font-semibold">500+</div>
			<div class="font-bold">{@html enjoyCol2Description}</div>
		</div>
		<div class="flex w-60 flex-col items-center text-center">
			<div class="text-xl font-semibold">200+</div>
			<div class="font-bold">{@html enjoyCol3Description}</div>
		</div>
	</div>
	<Link variant="tertiary" asButton {href} class="mx-auto mt-8">
		{@html tryApp}
	</Link>
</div>
